import { useMutation, useQuery, useQueryClient } from "react-query";

import { fetchCityOptions } from "../../../Checkout/services/getCities";
import {
  deleteAddressById,
  getAllAddresses,
} from "../../../_virtual-consultancy/services/api";
import { successToast, errorToast } from "../../../services/toasts";
import {
  getShippingCost,
  getShippingCostByCompanyName,
  getShippingCarriers,
} from "../../../supplierCheckout/services/api";
import { QUERY_KEYS } from "../queryKeys";

export const useGetCities = () => {
  return useQuery([QUERY_KEYS.GET_CITIES], fetchCityOptions, {
    staleTime: 3600000,
  });
};

export const useGetAllAddresses = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.GET_ALL_ADDRESSES],
    queryFn: getAllAddresses,
  });
};

export const useDeleteAddress = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => deleteAddressById(id),
    onSuccess: () => {
      queryClient.invalidateQueries("addresses");
      successToast("Dirección eliminada con éxito");
    },
    onError: () => {
      errorToast("Hubo un error al eliminar la dirección");
    },
  });
};

export const useGetShippingCost = (shouldFetch: boolean) => {
  return useQuery({
    queryKey: [QUERY_KEYS.GET_SHIPPING_COST],
    queryFn: () => getShippingCost(),
    refetchOnWindowFocus: false,
    enabled: shouldFetch,
    onError: () => {
      errorToast(
        "Empresa transportadora no disponible o datos de envío incorrectos"
      );
    },
  });
};

export const useGetShippingCostByCompanyName = (
  shouldFetch: boolean,
  companyName: string,
  carrierName?: string
) => {
  return useQuery({
    queryKey: [
      QUERY_KEYS.GET_SHIPPING_COST_BY_COMPANY_NAME,
      companyName,
      carrierName,
    ],
    queryFn: () =>
      getShippingCostByCompanyName(
        companyName,
        carrierName && carrierName.trim() ? carrierName : undefined
      ),
    refetchOnWindowFocus: false,
    enabled: shouldFetch,
    onError: () => {
      errorToast(
        "Empresa transportadora no disponible o datos de envío incorrectos"
      );
    },
  });
};

export const useGetShippingCarriers = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.GET_SHIPPING_CARRIERS],
    queryFn: () => getShippingCarriers(),
    refetchOnWindowFocus: false,
    onError: () => {
      errorToast("No se pudieron cargar las empresas transportadoras");
    },
  });
};
